import { defineComponent as _defineComponent } from 'vue'
import type { GetSamlConnectionsResponse } from '@/interfaces/api/general/saml';
import SamlSettingCard from './SamlSettingCard.vue';
import { defineMessages } from '@/lib/i18n';
import sharedMessages from '@/lib/shared-messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SamlSettingPageDemo',
  setup(__props) {

const dummySettingList: GetSamlConnectionsResponse = [
  {
    active: true,
    provider: 'Microsoft Entra ID',
    idp_entity_id: 'http://entity-id.example',
    acs_url: 'http://acs-url.example',
    idp_sso_url: 'http://sso-url.example',
    updated_at: '2025/01/01',
  },
];

const m = defineMessages({
  descprition:
    '「SAML認証オプション」を追加購入いただいたお客様がご利用になれる機能です。お求めの場合は「お問い合わせ」からご連絡ください。',
});

return { __sfc: true,dummySettingList, m, SamlSettingCard, sharedMessages }
}

})